import { TRANSACTION_TYPES, TransactionDetailsServiceTypes } from 'shared/consts';
import { TransactionDetails } from 'store/transactions/types';
import { getEventDuration, getFormattedEventDuration, getFormattedEventTime } from './formatDate';

interface ReceiptInfo {
  title: string;
  eventBlockSubtitle?: string;
}

// eslint-disable-next-line max-lines-per-function
export const getReceiptInfoFromTransaction = (
  transaction: TransactionDetails,
  locale: string,
  timezone?: string,
): ReceiptInfo => {
  if (transaction.type === TRANSACTION_TYPES.MEMBERSHIP) {
    return { title: 'summary' };
  }
  if (transaction.type !== TRANSACTION_TYPES.SERVICES_BOOKING) {
    return { title: 'default_details' };
  }

  switch (transaction.details.service?.type) {
    case TransactionDetailsServiceTypes.APPOINTMENT:
      return {
        title: 'appointment_details',
        eventBlockSubtitle: `${getFormattedEventTime(
          transaction.details.start_at,
          locale,
          timezone,
        )} / ${getEventDuration(transaction?.details?.start_at, transaction?.details?.end_at)} min`,
      };
    case TransactionDetailsServiceTypes.CLASS:
      return {
        title: 'class_details',
        eventBlockSubtitle: getFormattedEventDuration(
          transaction.details.start_at,
          transaction.details.end_at,
          locale,
          timezone,
        ),
      };
    case TransactionDetailsServiceTypes.EVENT:
      return {
        title: 'default_details',
        eventBlockSubtitle: getFormattedEventDuration(
          transaction.details.start_at,
          transaction.details.end_at,
          locale,
          timezone,
        ),
      };
    default:
      return { title: 'default_details' };
  }
};
